export default __webpack_public_path__ + "static/Video-b96d523e8ddb146c77e5b878ac9bdee9.mp4";